import React from 'react'
import {Button} from './core/button.js'

export default class StartScreen extends React.Component{
	render(){
		const {
			data,
			handler,
			lang
		} = this.props
		const startscreenData = data.screen_1
		const headline = startscreenData.text_1
		const icon = startscreenData.icon.filename
		const info = startscreenData.text_2
		const button = startscreenData.button
		const assetpath = lang.concat('/screen_1/', icon)

		return(
			<div className='startContainer'>
				<div className ='headline'>{headline}</div>
				<div className ='icon' style={{'backgroundImage': `url(${assetpath})`}}/>
				<div className ='info'>{info}</div>
				<Button
					className={'bottomButton button'}
					name={button}
					handler={handler}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/startScreen.js